
import { useTranslation, Trans } from 'react-i18next';
import React, { useCallback } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate /*, useRevalidator, useLocation */ } from 'react-router-dom'
//import { useParams } from "react-router";

// function useRevalidate() {
//     // We get the navigate function from React Rotuer
//     let navigate = useNavigate();
//     // And return a function which will navigate to `.` (same URL) and replace it
//     return useCallback(function revalidate() {
//         navigate('.', { replace: true });
//     }, [navigate]);
// }


export const LanguageSwitcherButton = () => {
    const { t, i18n: { language, changeLanguage } } = useTranslation();
    //const { lang } = useParams();// not able to pickup the correct parameters, if modified outside react's framework.
    let navigate = useNavigate();
    //const revalidator = useRevalidator();
    //const location = useLocation();
    
    const handleLanguageSwitching = useCallback((language) => {
        changeLanguage(language, (err, t1) => {
            if (err) return console.log('Language could not be switched!', err);
            else console.log('Language switched to ' + language + ' successfully!');
            //t1('TrackOrderFormPage.title');
            
            //navigate('.', { replace: true });
            //navigate('.' + language.substring (0, 2), { replace: true });
            //navigate(0);
            
            // Add the language to the URL address bar
            //var address = window.location.href;
            
            //console.log ('page state: ', location.state);
            
            var lang = language;// assume the language from the localization API
            var languageFoundInURI = window.location.pathname.match(/*"/(.+?)/"*/ /*"^/(?:(?:(en|fr))+?)/.*$"*/ "^/(en.*?|fr.*?)/.*$");// find what language is specified in the URL, if it appears in the first path segment
            //var languageFoundInURI = window.location.pathname.match("(?<=\/)[\w-]+(?:(?=[\?\#])|$)");// find what language is specified in the URL, if it appears in the last path segment
            var languageToReplace;
            
            // The 2nd element in the array contains the value we want to find.
            if (languageFoundInURI && languageFoundInURI.length > 1)
            {
                languageToReplace = languageFoundInURI[1];

            }
            
            var newAddress = null;//generatePath(/*this.props.match.path*/location, {lang: language, trackingNumber: "123456"})
            
            // If there's no language specified in the URI, then just set the desired language, there's nothign to change.
            // if (lang === undefined)
            // {
            //     newAddress = /*window.location.origin +*/ `/${language}` + window.location.pathname;
            // }
            // else
            // {
                newAddress = /*window.location.origin +*/ window.location.pathname.replaceAll (`/${languageToReplace ? languageToReplace : lang}/`, `/${language}/`);
            // }
            
            // const currentRoute = Routes.params.find(
            //     route => matchPath(this.props.location.pathname, route)
            // )
            //routes.props
            //window.history.replaceState(null, "", window.location.origin + newAddress);
            
            //revalidator.revalidate();
            //navigate(0);
            navigate(newAddress, { replace: true });
            //navigate('.', { replace: true });
        })
    }, [changeLanguage, navigate]);


    var lang = language;

    // reformat the language specified in the URL to match the value required by the localization library:
    let englishKeys = ['e', 'en', 'enca'];
    let frenchKeys = ['f', 'fr', 'frca'];
    
    let isEnglish = englishKeys.includes (language.toLowerCase().replaceAll ('-', ''));
    let isFrench = frenchKeys.includes (language.toLowerCase().replaceAll ('-', ''));

    // Use the keys expected by the library
    if (isEnglish) lang = 'en';
    if (isFrench) lang = 'fr';
    
    
    // // TODO: Reload the data for the current page
    // const navigate = useNavigate();
    // navigate('.', { replace: true });
    
    return (
        <NavDropdown title={t(`Language.${lang}`)} id="nav-dropdown">
            <NavDropdown.Item eventKey="4.1" disabled={lang.toLowerCase().startsWith("en")}
                onClick={() => {
                    handleLanguageSwitching("en")
                }}>
                <Trans i18nKey="Language.en">English Default</Trans>
            </NavDropdown.Item>
            <NavDropdown.Item eventKey="4.4" disabled={lang.toLowerCase().startsWith("fr")}
                onClick={() => {
                    handleLanguageSwitching("fr")
                }}>
                <Trans i18nKey="Language.fr">French Default</Trans>
            </NavDropdown.Item>
        </NavDropdown>
    )
}